
import React, { Component } from 'react';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import { Link as RouterLink } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { H1 } from 'ui/Typography';


const StyledContentHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 20px;
  row-gap: 12px;
  padding: 30px 30px 25px 30px;
  
  @media (max-width: 1279px) {
    padding: 24px 15px 20px;
  }

  h1 {
    margin: 0;
  }
`;

const StyledLayout = styled.div`
  display: grid;
  height: 100dvh;
  overflow: auto;
`;

const StyledContentSimple = styled.div`
  padding: 0 30px 30px 30px;
  
  @media (max-width: 1279px) {
    padding: 0 15px 15px 15px;
    min-width: 0;
  }
`;

const StyledFilter = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 0 30px 20px 30px;
  
  @media (max-width: 1279px) {
    padding: 0 15px 15px 15px;
  }
  
  > * {
    flex: 0 0 auto;
    min-width: 0;
  }
`;

const Wrapper = styled.div`
  min-width: 0;
  
  ${props => props.rows && css`
    display: grid;
    grid-template-rows: ${props.rows};
  `};
`;

const TitleBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 1 auto;
  min-width: 0;

  h1 {
    min-width: 0;
    overflow-wrap: break-word;
  }
  
  @media (max-width: 767px) {
    flex: 1 1 auto;
  }
`;

const HeaderSearch = styled.div`
  flex: 1 1 220px;
  max-width: 320px;
  min-width: 180px;
  
  .MuiFormControl-root,
  .MuiTextField-root {
    width: 100%;
  }
  
  @media (max-width: 767px) {
    flex: 1 1 100%;
    max-width: none;
    width: 100%;
    order: 3;
  }
`;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  margin-left: auto;
  flex: 0 0 auto;
  
  @media (max-width: 767px) {
    order: 2;
    
    .MuiButton-label {
      font-size: 0;
      line-height: 0;
    }
    
    .MuiButton-startIcon,
    .MuiButton-endIcon {
      margin: 0;
    }
    
    .MuiButton-startIcon svg,
    .MuiButton-endIcon svg,
    .MuiButton-label > svg {
      font-size: 22px;
    }
    
    .MuiButton-root {
      min-width: 40px;
      padding: 6px 10px;
    }
  }
`;


export function ContentHeader({ title, search, middle, right, backUrl }) {
  const searchElement = search || middle;

  return (
    <StyledContentHeader>
      <TitleBlock>
        {backUrl ? (
          <IconButton
            component={RouterLink}
            to={backUrl}
            edge="start"
            size="small"
            aria-label="Назад"
          >
            <ArrowBackIcon />
          </IconButton>
        ) : null}
        <H1>{title}</H1>
      </TitleBlock>
      {searchElement ? <HeaderSearch>{searchElement}</HeaderSearch> : null}
      {right ? <HeaderRight className={'right'}>{right}</HeaderRight> : null}
    </StyledContentHeader>
  );
}

export default class Layout extends Component {

  static Header = ContentHeader;
  static ContentSimple = StyledContentSimple;
  static Filter = StyledFilter;
  static FilterContent = StyledFilter;

  render() {
    const { rows, loading, ...otherProps } = this.props;
    return (
      <StyledLayout
        className={this.props.className}
        {...otherProps}
      >
        <Wrapper rows={rows}>
          {this.props.children}
        </Wrapper>
      </StyledLayout>
    )
  }
}
